export const getRulesetListResponse = (response) => {
  const totalData = response?.totalCount ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;

  const scheduleRulesets = response?.scheduleRulesets?.map((item) => {
    return {
      id: item?.id,
      brandName: item?.brandName,
      account: item?.accountLivestreams,
      type: item?.type,
      totalHost: item?.totalHost,
      liveHours: item?.liveHours,
      rawData: item,
    };
  });

  return { scheduleRulesets, totalData, totalPage, isDataExist };
};

export default getRulesetListResponse;
